/** Shared membership pricing tiers (CoolClimate Needs Assessment, 2025). Used by home page and outreach. */

export const MEMBERSHIP_SIGNUP_URL = '/membership/apply';
export const MEMBERSHIP_DEMO_URL = '/demo';

export const MEMBERSHIP_PRICING_TIERS = {
  rows: [
    {
      population: 'City <50k',
      ghgInventoryCost: 16628,
      affiliateFee: 2500,
      affiliatePct: '15%',
      capCost: 92284,
      regularFee: 5000,
      regularPct: '5%',
    },
    {
      population: 'City 50k–100k',
      ghgInventoryCost: 35642,
      affiliateFee: 5000,
      affiliatePct: '14%',
      capCost: 275274,
      regularFee: 10000,
      regularPct: '4%',
    },
    {
      population: 'City 100k–500k',
      ghgInventoryCost: 35642,
      affiliateFee: 7500,
      affiliatePct: '21%',
      capCost: 275274,
      regularFee: 15000,
      regularPct: '5%',
    },
    {
      population: 'City 500k–1M',
      ghgInventoryCost: 38333,
      affiliateFee: 10000,
      affiliatePct: '26%',
      capCost: 292667,
      regularFee: 20000,
      regularPct: '7%',
    },
    {
      population: 'City >1M',
      ghgInventoryCost: 38333,
      affiliateFee: 20000,
      affiliatePct: '52%',
      capCost: 292667,
      regularFee: 40000,
      regularPct: '14%',
    },
  ],
} as const;
